import React from "react";
import Header from "../components/HeaderThree";
import MapSection from "../components/ContactUs";  

import '../styles/ContactUsPage.css';

const ContactUs = () => {
  return (
    <>
      <Header />

      <section className="contact-section ">
        <div className="hero-blue-overlay" />
        <MapSection />
        <div className="map-fullscreen">
          <iframe
            title="Vessella Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3805.810694917541!2d78.34343207564459!3d17.468772483432424!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93ae60714ebb%3A0x680760bbbba97cb!2sVessella%20Group!5e0!3m2!1sen!2sin!4v1767727608748!5m2!1sen!2sin"
            loading="lazy"
            allowFullScreen
          />
        </div>

      </section>
    </>

  );
};

export default ContactUs;
